import { FaqService } from './faq.service';
import { FileCabinetService } from './file-cabinet.service';
import { LoaderService } from './loader.service';
import { NotesService } from './notes.service';
import { PhoneHelper } from './phone-helper';
import { CustomFieldsService } from './custom-fields.service';
import { AppRouteChangeService } from './app-route-change.service';
import { AppRouteAppcuesService } from './app-route-appcues.service';
import { ErrorPopupService } from '../error-handling/error-popup.service';

export {
    FaqService,
    //FileCabinetService,
    LoaderService,
    ErrorPopupService,
    NotesService,
    PhoneHelper,
    CustomFieldsService,
    AppRouteChangeService,
    AppRouteAppcuesService
};
